<template>
  <div class="grid-content">
    <div class="loading" v-loading="loading">
      <el-form
        ref="campusTaxRateSetting"
        label-width="100px"
        label-position="left"
      >
        <el-row
          v-for="(item, index) in dataList"
          :key="index"
        >
          <el-col :span="8">
            <el-form-item
              label="校区"
            >
              <span>{{item.CampusName}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="1"></el-col>
          <el-col :span="8">
            <el-form-item
              label="税率"
            >
              <el-input-number v-model="item.TaxRate" size="small" class="input-width" :precision="2" controls-position="right" :min="0" :max="100" :disabled="options.isReadonly">
              </el-input-number>%
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="20">
            <hr />
          </el-col>
        </el-row>
      </el-form>
    </div>
    <el-row v-if="!options.isReadonly" class="cs-filter-row">
      <el-col :span="4" class="footer-left">
        <el-button
          size="medium"
          :disabled="submitBtnDisable"
          :type="submitBtnClass"
          @click="onSave"
          >保存更新</el-button
        >
      </el-col>
      <el-col :span="16" class="footer-right">
        <el-alert
          :closable="false"
          v-show="showError"
          v-bind:title="errorMessage"
          type="error"
          show-icon
        ></el-alert>
      </el-col>
    </el-row>
  </div>
</template>

<style lang="scss" scoped>
.el-col {
  span {
    height: 40px;
    line-height: 40px;
    padding-left: 10px;
    overflow: visible;
    white-space: nowrap;
    padding-right: 10px;
  }

  .el-input {
    text-align-last: center;
    min-width: 120px;
    width: 50%;
  }

  .el-form-item {
    margin-left: 10px;
  }
}
</style>

<script>
import {
  getCampusTaxRateList,
  saveCampusTaxRates
} from "../../service/common.service";

export default {
  props: {
    isActive: Boolean,
    options: {
      isReadonly: Boolean,
    },
  },
  data() {
    return {
      isLoadedData: false,
      loading: false,
      submitBtnClass: "primary",
      submitBtnDisable: false,
      showError: false,
      errorMessage: "",
      dataList:[]
    };
  },
  components: {},
  computed: {},
  created() {
    this.loadDataList();
  },
  updated() {

  },
  methods: {
    loadDataList(){
      if (!this.isActive){
        return;
      }
      this.loading = true;
      getCampusTaxRateList().then(result =>{
        if (result && result.success){
          let list = result.data;
          list.forEach(element => {
            if (!!element.TaxRate){
              element.TaxRate = element.TaxRate * 100;
            }
          });
          this.dataList = list;
        }
        this.loading = false;
        this.isLoadedData = true;
      }).catch(ex =>{
        this.loading = false;
        this.isLoadedData = true;
      });
    },
    onSave() {
      let list = [];
      this.dataList.forEach(ele =>{
        let obj = JSON.parse(JSON.stringify(ele)); 
        obj.TaxRate = obj.TaxRate / 100;
        list.push(obj);
      });
      this.showError = false;
      this.loading = true;
      saveCampusTaxRates(list).then(result => {
        if (!!result && result.success){
          this.$message.success("保存成功！");
        }
        this.loading = false;
      }).catch(e =>{
        this.loading = false;
      });
    },
  },
  watch: {
    isActive: function () {
      if (this.isActive && !this.isLoadedData) {
          this.loadDataList();
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/priceManagement/campusTaxRate.vue